
import { defineComponent, shallowReactive, toRefs, watch } from 'vue'
import { IndexBar, IndexAnchor, Cell, Skeleton, Toast, Popup } from 'vant'
import { request } from '@/utils/request'

interface RootObject {
  code: number
  entry: Entry
  msg: string
}

interface Entry {
  data: Data
}

type Data = Record<
  string,
  {
    k: string
    v: string
  }[]
>

const getData = async (url: string) => {
  try {
    const {
      data: {
        code,
        entry: { data }
      }
    } = await request.get<RootObject>(url)
    if (code == 0) {
      return data
    } else {
      Toast.fail('获取数据失败')
    }
  } catch {
    Toast.fail('获取数据失败')
  }
}

export default defineComponent({
  name: 'SelectCity',
  components: {
    Popup,
    Cell,
    IndexBar,
    IndexAnchor,
    Skeleton
  },
  props: {
    url: {
      type: String,
      default: ''
    },
    show: {
      type: Boolean,
      default: false
    },
    currentCity: {
      type: String,
      default: ''
    }
  },
  setup(props) {
    const res = shallowReactive<{ keys: string[]; list: Data | null }>({
      keys: [],
      list: null
    })
    const unwatch = watch(
      () => props.show,
      async v => {
        if (!v) return
        unwatch()
        const data = await getData(props.url)
        if (data) {
          res.keys = Object.keys(data)
          res.list = data
        }
      }
    )
    return {
      ...toRefs(res)
    }
  }
})
